import { PropsWithChildren, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../lib/hooks.ts';
import { createBuildingContext } from './BuildingContext.tsx';

export default function RequiresBuilding({children}: PropsWithChildren) {
    const selectedBuilding = useAppSelector(state => state.building.building)
    const user = useAppSelector(state => state.user.user)
    const navigate = useNavigate()
    const location = useLocation()

    // A fresh/hard page load resets Redux state, so `selectedBuilding` is undefined right after
    // one regardless of whether the user is actually signed in -- it can also just mean
    // BuildingSelector's own Firestore query (Header, mounted globally) hasn't resolved the
    // default building yet. Only redirect to /login when genuinely unauthenticated, mirroring
    // ProtectedRoute's own recovery path -- and never to "/home", which isn't a route this router
    // defines (the index route is "/"), so that navigate used to silently go nowhere and leave
    // this stuck forever on every page it wraps (Signup, Overview, Building, Parking,
    // ParkingReport, Migration, Reservations).
    useEffect(() => {
        if (!selectedBuilding && user == null) {
            navigate("/login?next=" + location.pathname)
        }
    }, [selectedBuilding, user, navigate, location.pathname]);

    if (selectedBuilding) {
        const context = createBuildingContext(selectedBuilding);
        return (
            <context.Provider value={selectedBuilding}>
                {children}
            </context.Provider>
        )
    } else {
        return (
            <div/>
        )
    }
}
